jQuery(document).ready(function($){

    $('.is-accordion-submenu-parent > a').click(function(){
        if ($(this).attr('href') != '#') {
            $(this).unbind('click');
        }
    });

    $('.archive__left__cont .widget_nav_menu .current-menu-item').each(function() {
        $(this).closest('.current-menu-parent').addClass('active');
    });

    $('.archive__left__cont .widget_nav_menu .menu-item-has-children > a').click(function(event) {
        event.preventDefault();
        var $parent = $(this).closest('.menu-item-has-children');
        $parent.find('.sub-menu').slideToggle('fast');
        $parent.toggleClass('active');
        $(this).unbind('click');
    });

});
